(function () {
    'use strict';

    // The ng-change directive does not work with a file input (<input type="file" />).
    // This is my fix

    angular
        .module(app.modules.common.name)
        .decorator('inputDirective', inputDirectiveDecorator);

    inputDirectiveDecorator.$inject = ['$delegate'];
    function inputDirectiveDecorator($delegate) {
        var original = $delegate[0].link.pre;
        $delegate[0].link.pre = preLink;
        return $delegate;

        function preLink(scope, element, attr, ctrls) {
            if (attr.type == 'file')
                attr.type = 'text';
            return original.apply(this, arguments);
        }
    }
})();